import React, { useState, useEffect } from 'react';
import { Grid, Tab, Tabs } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import Cookies from 'universal-cookie';
import Page from '../../layout/components/PageAuth.jsx';
import RegisterForm from './forms/RegisterForm';
import LogoColor from '../../assets/images/logo-master-color.png';
import Footer from '../../layout/components/FooterAuth';
import RightContent from './common/ContentRightSignup';
import LoginOption from './common/LoginOption';
import LoginForm from './forms/LoginForm.jsx';
import RightContentLogin from './common/ContentRightLogin';

function Register() {
  const location = useLocation();
  const routeParams = location.search;
  const [activeTab, setActiveTab] = useState(0);
  const searchParamsData = new URLSearchParams(routeParams);
  const routeParamsValue = searchParamsData.get('autopilot');
  const routeParamsNewUser = searchParamsData.get('newUser');
  if (routeParamsValue === 'true') {
    const cookies = new Cookies();
    cookies.set('autopilot', 'true', { path: '/' });
  }

  useEffect(() => {
    if (routeParamsNewUser) {
      setActiveTab(1);
    }
  }, []);

  useEffect(() => {
    setActiveTab(location.pathname.indexOf('register') > -1 ? 1 : 0);
  }, [location.pathname]);

  const handleChange = (e, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Page title="Register">
      <Grid container className="auth_view">
        <Grid item lg={6} md={12} sm={12} xs={12} className="auth_view_content customScrollbar">
          <div className="signup_holder">
            <div className="web_show">
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
            {/* <div className="signin_link web_show">
              Already a member?
              <Link to={_route('login')} className="login_acc_link">
                Sign in
              </Link>
            </div> */}
          </div>
          <div className="mob_show">
            <div>
              <a className="logo_reg" href="/">
                <img src={LogoColor} alt="Logo" className="logo_auth" />
              </a>
            </div>
          </div>
          <div className="form_main_content">
            <div className="signup_form_holder">
              <div className="title_reg_right">{activeTab === 1 ? 'Sign Up' : 'Log In'}</div>
              <p className="subtitle_reg_right web_show">And start growing your businesses.</p>
              <Tabs value={activeTab} onChange={handleChange} variant="fullWidth">
                {[{ title: 'Log In' }, { title: 'Sign Up' }].map((value, index) => (
                  <Tab key={index} tabIndex={index} label={value.title} />
                ))}
              </Tabs>
              {/* <div className="sigin_link_mob mob_show">
                Already a member?
                <Link to={_route('login')} className="login_acc_link">
                  Sign in
                </Link>
              </div> */}

              {activeTab === 0 ? <LoginForm /> : <RegisterForm />}

              <LoginOption btnText={activeTab === 0 ? 'Login' : 'Sign up'} />
            </div>
          </div>
          <Footer />
        </Grid>
        {activeTab === 0 ? <RightContentLogin /> : <RightContent />}
      </Grid>
    </Page>
  );
}

export default Register;
